import { useRequestMutation } from "../../../request/hooks/useRequestMutation";

export const useRequestEvent = () => ({
  mutationPost: useRequestMutation<
    any,
    { event: string; uuid: string; created_at: Date; body?: any }
  >({
    mutationFnRequestProps: ({ event, body, uuid, created_at }) => ({
      urlBackendPath: "/events",
      method: "POST",
      body: JSON.stringify([
        {
          uuid,
          type: event,
          body: body ?? null,
          created_at,
        },
      ]),
    }),
  }),
});
